module.exports = __webpack_public_path__ + "static/media/241968.cef62108.jpg";